<mj-record-form-container [Record]="record" [FormComponent]="this"
    (Navigate)="OnFormNavigate($event)"
    (DeleteRequested)="OnDeleteRequested()"
    (FavoriteToggled)="OnFavoriteToggled()"
    (HistoryRequested)="OnHistoryRequested()"
    (ListManagementRequested)="OnListManagementRequested()">

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="before-fields" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>

    <!-- ========================================
         FIELD PANELS
         ======================================== -->
    <!-- Category Details Section -->
    <mj-collapsible-panel
        SectionKey="categoryDetails"
        SectionName="Category Details"
        Icon="fa fa-tag"
        [Form]="this"
        [FormContext]="formContext">
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Name"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Description"
            Type="textarea"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="DisplayOrder"
            Type="number"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="IsActive"
            Type="checkbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="ImageURL"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>

    </mj-collapsible-panel>

    <!-- Hierarchy Information Section -->
    <mj-collapsible-panel
        SectionKey="hierarchyInformation"
        SectionName="Hierarchy Information"
        Icon="fa fa-sitemap"
        [Form]="this"
        [FormContext]="formContext">
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="ParentCategoryID"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
            LinkType="Record"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="RootParentCategoryID"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="ParentCategoryIDDepth"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="ParentCategoryIDPath"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="ParentCategoryIDIsLeaf"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="ParentCategoryIDChildCount"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>

    </mj-collapsible-panel>

    <!-- System Metadata Section -->
    <mj-collapsible-panel
        SectionKey="systemMetadata"
        SectionName="System Metadata"
        Icon="fa fa-cog"
        [Form]="this"
        [FormContext]="formContext">
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="__mj_CreatedAt"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="__mj_UpdatedAt"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>

    </mj-collapsible-panel>

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="after-fields" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>

    <!-- ========================================
         RELATED ENTITY PANELS
         ======================================== -->

    <!-- Product Categories Section -->
    <mj-collapsible-panel
        SectionKey="productCategories"
        SectionName="Product Categories"
        Icon="fa fa-tags"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('productCategories')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Product Categories','ParentCategoryID')"
                [NewRecordValues]="NewRecordValues('Product Categories','ParentCategoryID')"
                [AllowLoad]="IsSectionExpanded('productCategories')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('productCategories', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Products Section -->
    <mj-collapsible-panel
        SectionKey="products"
        SectionName="Products"
        Icon="fa fa-cheese"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('products')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Products','CategoryID')"
                [NewRecordValues]="NewRecordValues('Products','CategoryID')"
                [AllowLoad]="IsSectionExpanded('products')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('products', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Competition Entries Section -->
    <mj-collapsible-panel
        SectionKey="competitionEntries"
        SectionName="Competition Entries"
        Icon="fa fa-table"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('competitionEntries')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Competition Entries','CategoryID')"
                [NewRecordValues]="NewRecordValues('Competition Entries','CategoryID')"
                [AllowLoad]="IsSectionExpanded('competitionEntries')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('competitionEntries', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="after-related" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>
</mj-record-form-container>
        